import { CredentialPresets } from "./credential/index.ts";
import { GrantPresets } from "./grant/index.ts";
import { IdentityPresets } from "./identity/index.ts";
import { ResourcePresets } from "./resource/index.ts";

export const PresetMonitors = Object.freeze({
  ...GrantPresets,
  ...IdentityPresets,
  ...CredentialPresets,
  ...ResourcePresets,
});
